// extracted by mini-css-extract-plugin
export var drawerPaper = "_2c-0";
export var itemImage = "_2c-1";